const splitReadingSkillName = (skill) => {
  if (!skill) return "";

  return skill.split("- ")[1];
};

export default splitReadingSkillName;
